import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock, Sparkles } from "lucide-react";

/**
 * Fixed bottom call-to-action bar, visible only on mobile (< md).
 * Appears after the user scrolls past the hero to avoid competing with it.
 */
export default function MobileStickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 520);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="mobile-sticky-cta"
      aria-hidden={!visible}
      className={`fixed inset-x-0 bottom-0 z-[190] border-t border-black/10 bg-[rgba(255,255,255,0.92)] backdrop-blur px-4 pt-2.5 md:hidden transition-transform duration-200 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      style={{ paddingBottom: "max(0.625rem, env(safe-area-inset-bottom))" }}
    >
      <p className="mb-2 flex items-center justify-center gap-1.5 text-[11px] font-medium text-[color:var(--gold-600)]">
        <Sparkles className="h-3 w-3" />
        Posti consulenza limitati · max 4 progetti l'anno
      </p>
      <Link
        to="/prenota"
        data-testid="mobile-sticky-cta-button"
        className="flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-emerald-700 text-[15px] font-semibold text-white transition-colors duration-200 hover:bg-emerald-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300 focus-visible:ring-offset-2"
      >
        <CalendarClock className="h-4 w-4" />
        Prenota la call
      </Link>
    </div>
  );
}
